import { Component, OnInit, Inject, PLATFORM_ID, ChangeDetectorRef,ViewChild, ElementRef,AfterViewInit } from '@angular/core';
import { CoreEffects } from 'angular-engine/engine/state/effect/core.effects';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { MetaService } from 'angular-engine/engine/service/meta/meta.service';
import { EventInteraction } from 'angular-engine/engine/service/dynamic/event.interaction.service';
import { UserLoginService } from 'angular-engine/engine/service/user/user.login.service';
import { Subscription } from 'rxjs/Subscription';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import 'rxjs/add/observable/of';
import { DEVICE_INFO, APP_SETTINGS,  DeviceInfo } from 'angular-engine/modules/ng-express-engine/tokens';
import { MobileNavigationService } from 'angular-engine/engine/service/ui/mobile-navigation/mobile-navigation.service';
import * as moment from 'moment';
@Component({
  selector: 'app-user.info-container',
  templateUrl: './user.info-container.template.html',
  styleUrls: ['./user.info-container.style.scss']
})

export class UserInfoContainer {
  @ViewChild('devices') devicesEl :ElementRef;
  @ViewChild('profile') profileEl :ElementRef;
  
  public isClient: boolean = false;
  public profileDetails: any;
  public favoritesPlaylist: any;
  public registeredDevices: any;
  public toggleLabel = "VIEW MORE";
  private oauthSubscription: Subscription;
  private isMobile : boolean = false;
  public selectedTab = "favorites";
  private data: Array<any>;
  public isPhone: boolean = false;
  public logoutSubscription : Subscription;
  
  constructor(
    protected coreEffects: CoreEffects,
    private router: Router,
    protected metaService: MetaService,
    protected cd: ChangeDetectorRef,
    protected authService: UserLoginService,
    @Inject(PLATFORM_ID) protected platformId: string,
    private interactions : EventInteraction,
    private mobileNavSvc : MobileNavigationService,
    @Inject(DEVICE_INFO) device: DeviceInfo,
    
    
  ) {
    
    this.isClient = isPlatformBrowser(this.platformId);
    this.isPhone = device.isPhone;

    this.logoutSubscription =  this.interactions.subscribe( e => {
      if (e.key == "user-request-logout"){
        this.logout();
      }
    }) 
   }

  ngOnInit() {
    this.metaService.setDynamicSearchTitle("User Settings", "User");
    if (this.isClient){
      const self = this;
      this.oauthSubscription = this.authService.loginState.subscribe(e => {
          if (e ==  "stats_retrieved") {
                self.loadProfile();
          }
      });
      window.scrollTo(0, 0);

      var navCheck: any = document.getElementById('main-nav-check');
      if (navCheck) {
        navCheck.checked = false;
      }
    }
    this.loadProfile();
  }
  ngAfterViewChecked() {
    if(this.isPhone)
    {
      this.mobileNavSvc.registerClientObject(1, this.devicesEl);
      this.mobileNavSvc.registerClientObject(2, this.profileEl);
    }
  }
  private loadProfile(){
    //if (!this.profileDetails){
      let favorites = this.coreEffects.getInternalStateValue('favorites');
      this.profileDetails    = { meta: {title: "Profile"  }, data: this.coreEffects.getInternalStateValue('user_profile')};
      this.favoritesPlaylist = { 
        meta: {title: "Favorites"}, 
        data: favorites
      };
      this.registeredDevices = { meta: {title: "Devices"  }, data: this.coreEffects.getInternalStateValue('user_devices')};
      
      if( this.isPhone ){
        this.data  = [ this.favoritesPlaylist, this.registeredDevices, this.profileDetails ];
        this.mobileNavSvc.setData( { rows: this.data });
        this.mobileNavSvc.registerClientObject(1, this.devicesEl);
        this.mobileNavSvc.registerClientObject(2, this.profileEl);
      }
      this.cd.detectChanges();
    //}
  }

  private checkIfLoggedIn(){
    if (!this.profileDetails){
      this.router.navigateByUrl('/');
    }
  }

  ngOnDestroy(){
    if (this.oauthSubscription){
      this.oauthSubscription.unsubscribe();
      this.oauthSubscription = null;
    }
    if( this.logoutSubscription){
      this.logoutSubscription.unsubscribe();
      this.logoutSubscription = null;
    }
  }
  public selectTab( tab : string ){
    this.selectedTab = tab;
    this.loadProfile();
    this.cd.detectChanges;
  }

  public logout() {
    this.authService.logout();
    this.profileDetails = null;
    this.favoritesPlaylist = null;
    this.registeredDevices = null;
    this.coreEffects.setInternalStateValue('user_profile', null);
    this.coreEffects.setInternalStateValue('favorites', null);
    this.coreEffects.setInternalStateValue('user_devices', null);
    this.cd.detectChanges();
    this.router.navigateByUrl('/');
  }

  public position(index:number):string{
    if(this.isPhone)
    {
      const position = index * this.mobileNavSvc.windowWidth;
      return 'translateX(' + position + 'px)';
    }
    return '';
  }
}



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/containers/user.info-container/user.info-container.component.ts